import { ConfirmProvider } from '../ConfirmDialogContext'
import LangSelector, { LanguageSelectorProps } from './LanguageSelector'
export * from './LanguageSelector'

export default function LanguageSelector(props: LanguageSelectorProps) {
  // We need to wrap the LanguageSelector component in the ConfirmProvider
  return (
    <ConfirmProvider>
      <LangSelector {...props} />
    </ConfirmProvider>
  )
}
